import { Modal } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'

interface IModalProps {
    show: boolean
    onHide: () => void
    id: string | undefined
    poolShipId: number | undefined
    exist: number | undefined
    name: string | undefined
    /**
     * Which screen this modal was opened from. Carried into the wizard's
     * navigation state and read back as `entry_source` — the wizard has one
     * route and two doors, and without this they are the same door.
     */
    source?: 'fund_page' | 'admin_dashboard'
}
export default function AddNewLoanModal({
    show,
    onHide,
    id,
    poolShipId,
    exist,
    name,
    source = 'fund_page',
}: IModalProps) {
    const navigate = useNavigate()
    const { state } = useLocation()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className="">
                <p className=" text-center text-sm py-3 px-3">
                    آیا میخواهید وامی در گذشته اعطا شده را ثبت کنید یا میخواهید
                    وام جدید اعطا کنید؟
                </p>
                <hr />
            </div>
            <div className="">
                <p
                    className=" text-center text-sm py-3 text-green-1 cursor-pointer "
                    onClick={() => {
                        onHide()
                        navigate(`/loans/management/grant/${id}`, {
                            state: { exist, name, source },
                        })
                    }}
                >
                    اعطای وام جدید
                </p>
                <hr />
            </div>
            <div className="">
                <p
                    className=" text-center text-sm py-3 text-green-1 cursor-pointer "
                    onClick={() => {
                        onHide()
                        navigate(
                            `/loans/management/add-old/${id}/${poolShipId}`,
                            { state: { exist, name } }
                        )
                    }}
                >
                    ثبت وام اعطا شده در گذشته
                </p>
                <hr />
            </div>
            <div className="">
                <p
                    className=" text-center text-sm py-3 cursor-pointer "
                    onClick={onHide}
                >
                    بازگشت
                </p>
            </div>
        </Modal>
    )
}
